import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=d1c72e9c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1c72e9c')) {
      api.createRecord('d1c72e9c', component.options)
    } else {
      api.reload('d1c72e9c', component.options)
    }
    module.hot.accept("./VideoIcon.vue?vue&type=template&id=d1c72e9c", function () {
      api.rerender('d1c72e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/VideoIcon.vue"
export default component.exports